import React, { useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes, Outlet, useLocation } from 'react-router-dom';
import { GlobalContextProvider } from './utils/GlobalContext';
import useKonamiCode from './utils/useKonamiCode';
import Info from './pages/Info';
import Links from './pages/Links';
import Things from './pages/things/Things';
import ThingDetail from './pages/ThingDetail';
import Notes from './pages/Notes';
import Versions from './pages/Versions';
import DesktopPage from './pages/DesktopPage';
import Subscribe from './pages/Subscribe';
// TOS.js and Storage.js are no longer routed — content is now combined
// in Notes.js. Source files preserved for reference.
// Hibernated pages (files preserved in pages/, not routed, dropped from build):
//   ThingFMDev, CRTLab, Station — WIP visual experiments. Re-enable later
//   by re-adding the import + Route line.
// Removed permanently — superseded by dedicated projects:
//   Radio (now ~/Thingdoms Workspace/radio/)
//   Signals + SignalDetail (now ~/Thingdoms Workspace/signals/)
import './Header.css';
import './App.css';
import Header from './Header';
import Rain from './utils/Rain';
import Snow from './utils/Snow';
import useWeather from './utils/useWeather';

// Add ?weather=rain,snow to URL to force effects
function useWeatherDev(realWeather) {
  const params = new URLSearchParams(window.location.search);
  const forced = params.get('weather');
  if (!forced) return realWeather;
  const effects = forced.split(',');
  return {
    rain: effects.includes('rain'),
    snow: effects.includes('snow'),
  };
}

function ArchivalLayout() {
  const realWeather = useWeather();
  const weather = useWeatherDev(realWeather);

  return (
    <div className="App">
      {weather.rain && <Rain />}
      {weather.snow && <Snow />}
      <Header />
      <Outlet />
    </div>
  );
}

function KonamiListener() {
  useKonamiCode(useCallback(() => {
    window.location.href = '/desktop';
  }, []));
  return null;
}

export default function App() {
  return (
    <GlobalContextProvider>
      <Router>
        <KonamiListener />
        <Routes>
          <Route path="/desktop" element={<DesktopPage />} />
          <Route element={<ArchivalLayout />}>
            <Route path="/" element={<Things />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/versions" element={<Versions />} />
            <Route path="/info" element={<Info />} />
            <Route path="/links" element={<Links />} />
            <Route path="/mail" element={<Subscribe />} />
            <Route path="/things/:id" element={<ThingDetail />} />
          </Route>
        </Routes>
      </Router>
    </GlobalContextProvider>
  );
}
